import React from "react";
import styled from "styled-components";
import { AppBar, Box, BoxProps, Tab } from "@material-ui/core";
import { TabPanel, TabPanelProps } from "@material-ui/lab";
import { orange } from "@material-ui/core/colors";
import { INFO_PANEL_OFFSET } from "styles/utils";

export const InfoPanelContainer = styled(Box)<BoxProps>`
    ${({ theme }) => theme.breakpoints.up("md")} {
        width: 40vw;
    }
    // TODO: uncomment and set proper value when business will finally make some decisions ;)
    ${({ theme }) => theme.breakpoints.up("lg")} {
        width: 33vw;
    }

    height: 100%;
    width: 30vw;
    position: sticky;
    top: 0;
    align-self: flex-start;
`;

export const InfoTabPanel = styled(
    ({ stickyFooter, stickyHeader, ...props }: TabPanelProps & { stickyFooter?: boolean; stickyHeader?: boolean }) => (
        <TabPanel {...props} />
    )
)`
    min-height: 100%;
    width: 100%;
    height: auto;
    padding: ${({ theme }) => theme.spacing(2)}px;

    ${({ stickyHeader, stickyFooter }) => {
        return `
            ${stickyHeader ? "padding-top: 0;" : ""}
            ${stickyFooter ? "padding-bottom: 0;" : ""}
        `;
    }}
`;

export const InfoPanelContent = styled(Box)`
    overflow: auto;
    height: calc(100% - ${INFO_PANEL_OFFSET}px);
    display: flex;
    width: 100%;
`;

export const InfoAppBar = styled(AppBar)`
    background-color: white;
    color: black;

    .Mui-selected {
        background-color: white;
    }

    .MuiTabs-indicator {
        background-color: ${orange["700"]};
        height: 3px;
    }
`;

export const NarrowedTab = styled(Tab)`
    &.MuiTab-root {
        min-width: ${({ theme }) => theme.spacing(10)}px;
        font-weight: bold;
    }
`;
